import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { AccessRequestService } from '@appStore/account/services/access-request.service';
import { ActionTypes } from '@appStore/account/actions';
import * as actions from '@appStore/account/actions';

@Injectable()
export class AccessRequestsEffects {
    constructor(private accessRequestService: AccessRequestService, private actions$: Actions) {}

    loadMyAccessRequests$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ActionTypes.MyAccessRequestsLoad),
            exhaustMap(action => {
                return this.accessRequestService.getMyAccessRequests().pipe(
                    map(accessRequests => new actions.MyAccessRequestsLoadSuccess(accessRequests)),
                    catchError(error => of(new actions.MyAccessRequestsLoadFail(error)))
                );
            })
        );
    });

    removeAccessRequest$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ActionTypes.MyAccessRequestsRemove),
            exhaustMap((action: actions.MyAccessRequestsRemove) => {
                return this.accessRequestService.removeAccessRequest(action.payload).pipe(
                    map(() => new actions.MyAccessRequestsRemoveSuccess(action.payload.id)),
                    catchError(error => of(new actions.MyAccessRequestsRemoveFail(error)))
                );
            })
        );
    });
}